import './App.css';
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";

import Navbar from "./components/Navbar";
import Home from "./pages/home"; 
import Calisthenics from "./pages/calisthenics";
import Breathwork from "./pages/breathwork";
import Mobility from "./pages/mobility";
import Nutrition from "./pages/nutrition";
import Contact from "./pages/contact";
// import AllBlogs from "./pages/allblogs";
import Service from "./pages/terms-of-service";
import PrivacyPolicy from "./pages/privacy-policy";
import RefundPolicy from "./pages/refund-policy";
// import BlogPage from "./pages/BlogPage"; 

function App() {
  
  const [allBlogs, setAllBlogs] = useState(() => {
    const saved = localStorage.getItem("teqnoor_blogs");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const res = await axios.get("https://www.api.teqnoor.info/api/v1/blog/");
        const blogsData = res.data.blogs || [];
        setAllBlogs(blogsData);
        // Save to localStorage for instant access next time
        localStorage.setItem("teqnoor_blogs", JSON.stringify(blogsData));
      } catch (err) {
        console.error("Data fetching error:", err);
      }
    };
    fetchAllData();
  }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        {/* 2. HOME page ko allBlogs pass karo taake wo dobara fetch na kare */}
        <Route path="/" element={<Home allBlogs={allBlogs} />} />
        
        <Route path="/calisthenics" element={<Calisthenics />} />
        <Route path="/breathwork" element={<Breathwork />} />
        <Route path="/mobility" element={<Mobility />} />
        <Route path="/nutrition" element={<Nutrition />} />
        <Route path="/contact" element={<Contact />} />
        
       
        {/* <Route path="/allblogs" element={<AllBlogs allBlogs={allBlogs} />} /> */}
        
       
        {/* <Route path="/journal/:id" element={<BlogPage allBlogs={allBlogs} />} /> */}

        <Route path="/terms-of-service" element={<Service />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;